
// --
// SHARE DIALOG
// --
//
// this is base class which the indiviual share classes (facebook,twitter,linkedin,email) extend off
//


// --
// USAGE
// --
//
// data-component="share-linkedin" data-component-options='{"shareURL":"[url-to-share]"}'
//
// "shareURL" is the site url to share ie http://uniondigital.co.nz
//


import _Abstract from "system/abstract"

export default class Component_share_base extends _Abstract {

  constructor(el, options) {

    super(el, $.extend(true, {

      'windowTarget':'',
      'windowName':'',
      'windowParams':''

    }, options), 'component');

    // bind events function
    this.bindEvents();

  }

  bindEvents() {

    // bind click event on this element
    this.$el.on('click', (e) => this.triggerShare(e));

  }

  //Makes sure the options stored are the latest based on the elements data options (as may be dynamically replaced)
  readLatestElementOptions()
  {
    var latestOptions = this.$el.data("component-options");


    for(var key in latestOptions)
    {
      var value = latestOptions[key];

      this.options[key] = value;
    }

  }

  // function to pass share dteials to the share dialog
  triggerShare(event){

    this.readLatestElementOptions();

    event.preventDefault();

    this.openSharePopup(this.options.shareURL,this.options.windowTarget,this.options.windowName,this.options.windowParams);

  }

  // open share dialog
  openSharePopup(shareURL,windowTarget,windowName,windowParams){

    window.open(windowTarget+encodeURIComponent(shareURL), windowName, windowParams);

  }

  // open share link
  openShareLink(shareURL,windowTarget){

    window.location.href = windowTarget+encodeURIComponent(shareURL);

  }


}





/** WEBPACK FOOTER **
 ** ./components/_share-base.js
 **/